export default "__VITE_ASSET__R8Hrd$1D__"